<template>
  <div ref="chart" id="chart"></div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as am4charts from '@amcharts/amcharts4/charts';

export default {
  props: {
    data: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      chart: {},
      series: {},
    };
  },
  computed: {
    ...mapGetters([
      'am4core',
    ]),
  },
  mounted() {
    this.generateGraphic();
  },
  methods: {
    generateGraphic() {
      this.chart = this.am4core.create(this.$refs.chart, am4charts.PieChart);
      this.chart.height = this.am4core.percent(100);
      this.chart.data = this.data;
      this.chart.tooltip.disabled = true;
      this.chart.innerRadius = this.am4core.percent(30);
      this.chart.radius = this.am4core.percent(50);

      // Create series
      const series = this.chart.series.push(new am4charts.PieSeries());
      series.dataFields.value = 'value';
      series.dataFields.category = 'category';
      series.ticks.template.disabled = true;
      series.labels.template.html = '<div style="text-align: center;"> <span style="font-weight:200; font-size:15px;"> {value} </span> <br/> <span style="font-size:10px; font-weigth:100; color: grey"> {category} </span> </div>';
      series.alignLabels = false;

      series.colors.list = [];
      for (let i = 0; i < this.data.length; i += 1) {
        if (this.am4core) {
          series.colors.list.push(this.am4core.color(this.data[i].color));
        }
      }
      this.series = series;
      const slice = series.slices.template;
      slice.states.getKey('hover').properties.scale = 1;
      slice.states.getKey('active').properties.shiftRadius = 0;
      slice.tooltipText = '';
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.chart.data = this.data;
        this.series.colors.list = [];
        for (let i = 0; i < this.data.length; i += 1) {
          if (this.am4core) {
            this.series.colors.list.push(this.am4core.color(this.data[i].color));
          }
        }
      },
    },
  },
};
</script>
<style scoped>
#chart {
  height: 250px;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/chat_center_v2/dashboard/Distributions/Donnut.vue